import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

export function HomePage() {
  const { t } = useTranslation();
  const { user } = useAuth();
  const navigate = useNavigate();

  if (!user) return null;

  return (
    <div className="h-full p-6 max-w-2xl mx-auto">
      <h1 className="text-xl font-semibold mb-1">
        {t("home.greeting", { name: user.name })}
      </h1>
      <p className="text-slate-400 text-sm mb-6">{t("home.subtitle")}</p>

      <div className="grid grid-cols-2 gap-3">
        <button
          onClick={() => navigate("/reports/new")}
          className="bg-sky-600 hover:bg-sky-500 rounded-lg py-6 text-center font-medium transition duration-200 ease-out"
        >
          {t("home.action.newReport")}
        </button>
        <button
          onClick={() => navigate("/reports")}
          className="bg-slate-700 hover:bg-slate-600 rounded-lg py-6 text-center font-medium transition duration-200 ease-out"
        >
          {t("home.action.list")}
        </button>
        {(user.role === "admin" || user.role === "manager") && (
          <button
            onClick={() => navigate("/admin")}
            className="col-span-2 bg-slate-800 hover:bg-slate-700 rounded-lg py-4 text-sm transition duration-200 ease-out border border-slate-700"
          >
            {t("home.action.admin")}
          </button>
        )}
      </div>
    </div>
  );
}
